// extracted by mini-css-extract-plugin
export default {"navItem":"NavItem_navItem__bfXap","active":"NavItem_active__csjDN","disabled":"NavItem_disabled__3+1a3"};